module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/events/events-index/events-index.component.scss
// module id = ./src/app/routes/events/events-index/events-index.component.scss
// module chunks = 9